import styled, { css } from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  type?: 'type1' | 'type2' | 'type3' | 'type4' | 'type5' | 'type6' | 'type7'; // type1: 모션, type2: square, type3: round, type4: text, type5: underBar, type6: round white, type7: round white2
  mode?: string | undefined;
}

export const LeaveMenuBarItem = styled.div<IProps>`
  ${props => {
    switch (props.type) {
      case 'type2':
        return css`
          .area-click {
            height: 29px !important;
            padding: 7px 10px;
            border: 1px solid #eee;
            border-radius: 6px;
            font-size: 13px;
            color: #000;
            white-space: pre-wrap;
          }

          &.active {
            .area-click {
              border: 1px solid #000;
              color: #000;
            }
          }

          .icon-my {
            width: 13.9px;
            height: 8px;
            margin-right: 3px;
          }
        `;
      case 'type3':
        return css`
          .area-click {
            height: 30px;
            padding: 0 10px;
            border: 1px solid #eee;
            border-radius: 50px;
            font-size: 13px;
            color: #555;
            background-color: #f6f6f6;
          }

          &.active {
            .area-click {
              border: none;
              color: #fff;
              background-color: #000;
            }
          }
        `;
      case 'type6':
        return css`
          .area-click {
            height: 32px;
            padding: 0 16px;
            line-height: 130%;
            border-radius: 30px;
            border: 1px solid #e2e2e2;
            font-size: 14px;
            font-weight: 400;
            color: #acacac;
          }

          &.active {
            .area-click {
              border: 1px solid #000;
              color: #000;
            }
          }
        `;
      case 'type7':
        return css`
          .area-click {
            height: 32px;
            padding: 0 16px;
            line-height: 130%;
            border-radius: 30px;
            border: 1px solid #eee;
            font-size: 14px;
            font-weight: 400;
            color: #555;
          }

          &.active {
            .area-click {
              border: 1px solid #000;
              background-color: #000;
              color: #fff;
            }
          }

          &.filter.active {
            .area-click {
              border: 1px solid #000;
              background-color: transparent;
              color: #000;

              svg path {
                fill: #000 !important;
              }
            }
          }

          .icon-filter {
            margin-left: 2px;
          }
        `;
      default:
        return null;
    }
  }}
  @media
    ${({ theme }) => theme.media.smMax} {
    ${props => {
      switch (props.type) {
        case 'type2':
          return css`
            .area-click {
              height: ${mixin.pxToVw('29')};
              font-size: ${mixin.pxToVw('13')};
              border-radius: ${mixin.pxToVw('6')};
            }

            .icon-my {
              width: ${mixin.pxToVw('13.9')};
              height: ${mixin.pxToVw('8')};
              margin-right: ${mixin.pxToVw('3')};
            }
          `;
        case 'type3':
          return css`
            .area-click {
              height: ${mixin.pxToVw('30')};
              padding: ${mixin.pxToVw('0 10')};
              border-radius: ${mixin.pxToVw('50')};
              font-size: ${mixin.pxToVw('13')};
            }
          `;
        case 'type6':
          return css`
            .area-click {
              height: ${mixin.pxToVw('32')};
              padding: ${mixin.pxToVw('0 16')};
              border-radius: ${mixin.pxToVw('30')};
              font-size: ${mixin.pxToVw('14')};
            }
          `;
        case 'type7':
          return css`
            .area-click {
              height: ${mixin.pxToVw('32')};
              padding: ${mixin.pxToVw('0 16')};
              border-radius: ${mixin.pxToVw('30')};
              font-size: ${mixin.pxToVw('14')};
            }

            .icon-filter {
              margin-left: ${mixin.pxToVw('2')};
            }
          `;
        default:
          return null;
      }
    }}
  }

  @media ${({ theme }) => theme.media.pc} {
    ${props => {
      switch (props.type) {
        case 'type2':
          return css``;
        case 'type3':
          return css`
            .area-click {
              height: 46px;
              padding: 0 22px;
              border: none;
              border-radius: 100px;
              font-size: 17px;
              color: #555;
              background-color: #f6f6f6;
            }
          `;
        case 'type6':
          return css`
            .area-click {
              height: 37px;
              font-size: 16px;
            }
          `;
        case 'type7':
          return css`
            .area-click {
              height: 37px;
              font-size: 16px;
            }

            .icon-filter {
              margin-left: 4px;
            }
          `;
        default:
          return null;
      }
    }}
  }
`;
